import React from "react";
import cn from "classnames";
import "./HhIcon.scss";

const HhIcon = ({ width = 20, height = 10, className, style, onClick }) => (
  <svg
    className={cn("hh_icon", className)}
    width={width}
    height={height}
    style={style}
    onClick={onClick}
    viewBox="0 0 20 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="hh_icon-text"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.85224 0V3.85942C2.4484 3.15883 3.16293 2.80587 3.99181 2.80587C4.38914 2.79976 4.78278 2.88174 5.14364 3.04575C5.48761 3.20403 5.7457 3.40687 5.91791 3.65428C6.09199 3.90175 6.21321 4.18152 6.27418 4.4766C6.33783 4.7757 6.3696 5.24107 6.36949 5.87271V10H4.51731V6.28319C4.51731 5.54613 4.48377 5.07834 4.41328 4.88023C4.34682 4.68573 4.21566 4.51905 4.04106 4.40723C3.84146 4.28307 3.60845 4.22127 3.37259 4.22993C3.08228 4.22574 2.7969 4.30422 2.55072 4.45594C2.30023 4.61608 2.11289 4.8559 2.01987 5.13554C1.90687 5.43808 1.85099 5.88489 1.85224 6.47598L1.85031 10H0V0H1.85224Z"
    />
    <path
      className="hh_icon-text"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.21987 0V3.85942C8.81587 3.15883 9.53034 2.80587 10.3592 2.80587C10.7571 2.80013 11.1512 2.88208 11.5129 3.04575C11.8549 3.20403 12.1123 3.40687 12.2851 3.65428C12.4592 3.90176 12.5804 4.18153 12.6415 4.4766C12.705 4.7757 12.7368 5.24107 12.7368 5.87271V10H10.8866V6.28319C10.8866 5.54614 10.8514 5.07849 10.7809 4.88023C10.7145 4.68569 10.5833 4.519 10.4086 4.40723C10.2321 4.28909 10.0081 4.22993 9.74011 4.22993C9.4498 4.22577 9.16444 4.30424 8.91824 4.45594C8.6688 4.6172 8.48178 4.85662 8.38739 5.13554C8.2763 5.43808 8.2205 5.88489 8.21998 6.47598V10H6.36951V0H8.21987Z"
    />
    <g className="hh_icon-badge" transform="translate(16.37, 6.37) scale(1.3) translate(-16.37, -6.37)">
      <path
        className="hh_icon-badge-circle"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 6.40672C20 7.11469 19.787 7.80676 19.3879 8.3954C18.9889 8.98405 18.4217 9.44284 17.7581 9.71376C17.0945 9.98467 16.3643 10.0555 15.6598 9.91741C14.9553 9.77928 14.3083 9.43835 13.8004 8.93772C13.2925 8.4371 12.9466 7.79928 12.8065 7.10491C12.6664 6.41054 12.7383 5.69082 13.0132 5.03675C13.2881 4.38268 13.7536 3.82365 14.3509 3.43034C14.9481 3.03703 15.6502 2.82712 16.3685 2.82715C16.8454 2.82708 17.3177 2.91963 17.7583 3.0995C18.199 3.27937 18.5993 3.54304 18.9366 3.87545C19.2738 4.20786 19.5413 4.60249 19.7237 5.03682C19.9062 5.47114 20.0001 5.93664 20 6.40672Z"
      />
      <path
        className="hh_icon-ru"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8757 7.78164H14.1703V5.1578H14.8241V5.53019C14.9376 5.35467 15.0368 5.23856 15.1271 5.18335C15.2181 5.12625 15.324 5.0967 15.4318 5.09833C15.5958 5.09953 15.7563 5.1451 15.8957 5.23006L15.6774 5.83466C15.5803 5.76597 15.465 5.7266 15.3456 5.72135C15.2555 5.71909 15.1674 5.74706 15.0957 5.80065C15.0266 5.85445 14.972 5.95213 14.9332 6.09099C14.8946 6.23269 14.8754 6.52625 14.8757 6.97167L14.8757 7.78164Z"
      />
      <path
        className="hh_icon-ru"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9257 7.78168V7.38945C17.8281 7.52931 17.6968 7.64314 17.5436 7.72075C17.3889 7.8005 17.2167 7.84181 17.0422 7.8411C16.8747 7.84409 16.7094 7.80406 16.5624 7.72495C16.4251 7.65325 16.3163 7.53806 16.2535 7.39795C16.1903 7.25918 16.1588 7.06519 16.1588 6.8174V5.15784H16.8626V6.36287C16.8626 6.73238 16.8755 6.959 16.9015 7.04114C16.9247 7.1208 16.9742 7.19055 17.0422 7.23934C17.1195 7.28982 17.211 7.31507 17.3037 7.31151C17.419 7.31365 17.5322 7.28 17.6271 7.2153C17.7172 7.15758 17.7857 7.07259 17.8225 6.97313C17.8585 6.87686 17.8757 6.64041 17.8757 6.26518V5.15784H18.581V7.78168H17.9257Z"
      />
    </g>
  </svg>
);

export default HhIcon;
